import { WORDING_ERROR } from "constants/messages/error";

// eslint-disable-next-line import/prefer-default-export
export const errorMessage = {
  wording: WORDING_ERROR,
};
